
import { Component, Prop, Watch, Vue } from "vue-property-decorator"
import FormField from "../../base_classes/FormField"

import { Formatting } from "../../util/formatting"

@Component
export default class DurationField extends FormField {
    @Prop() label!: string
    @Prop() field!: string
    @Prop() errorRequired!: boolean
    show = false

    hour: any = null    //this.value[this.field] ? Math.floor(this.value[this.field] / 60) : 0
    minute: any = null  //this.value[this.field] ? this.value[this.field] % 60 : 0

    // this should be a global const but for some reason that's not working
    dateFormat = new Formatting.DateFormatting()

    get changed() {
        //if (!this.duration && !this.value[this.field]) return false
        return this.duration != this.value[this.field]
    }

    get duration() {
        let duration = this.hour ? Math.round(this.hour) * 60 : 0
        duration += this.minute ? Math.round(this.minute) : 0
        return duration
    }

    mounted() {
        this.setHourAndMinute()
    }

    @Watch("show")
    onShowChange() {
        this.setHourAndMinute()
    }

    @Watch("value.workDuration")
    onDurationChange(val: number) {
        if (this.field == "workDuration") this.setHourAndMinute()
    }

    setHourAndMinute() {
        this.hour = this.value[this.field] ? Math.floor(this.value[this.field] / 60) : this.zeroSet ? 0 : null
        this.minute = this.value[this.field] ? this.value[this.field] % 60 : null
        if (this.minute == 0) this.minute = null
    }

    changeSilent(mins: number) {
        this.value[this.field] = mins || null
    }

    input() {
        if (this.errorRequired) this.$emit("clearErrorRequired", this.field)
    }

    get formattedDuration() {
        if (this.zeroSet) return "0"
        var mins = this.value[this.field]
        var hrs = this.dateFormat.duration(mins)
        return mins > 0 && hrs != null ? hrs : null
    }

    clickClear() {
        this.hour = null
        this.minute = null
        this.value[this.field] = null
        this.$emit("input", this.value)
        this.$emit("change", this.field, this.duration)
    }

    cancelEdit() {
        this.setHourAndMinute()
        this.show = false
    }

    zeroSet = false
    get getZeroSet() { return this.zeroSet }

    submitTime(keyup: any) {
        if ((this.field == "pauseDuration" && !keyup) || (this.field == "workDuration" && keyup)) return
        this.show = false
        this.value[this.field] = this.duration
        this.zeroSet = this.duration === 0 && !this.isEmpty()
        this.$emit("input", this.value)
        this.$emit("change", this.field, this.duration)
    }

    isEmpty(){
        return (this.hour === null || this.hour === "") && (this.minute === null || this.minute === "")
    }

    get icon() {
        if (this.field == "pauseDuration") return "pause_circle"
        if (this.field == "workDuration") return "timer"
    }
    setMinutes(minute: number) {
        this.minute = minute
    }
    setHour(hour: number) {
        this.hour = hour
    }
}
